import React from 'react';
import Admin from 'hive-admin';
import { ADMIN as FILTERS_ADMIN, SELLER as FILTERS_SELLER } from './filters';
import { ADMIN as COLUMNS_ADMIN, SELLER as COLUMNS_SELLER } from './columns';
import { ADMIN as FIELDS_ADMIN, SELLER as FIELDS_SELLER } from './fields';

import { getI18nFields } from '../../helpers/i18n';

export default [
  ['ADMIN', {
    path: '/billing-invoicing/payout',
    archiveLoadUrl: '/orders/billing-invoicing/payout',
  }],
  ['SELLER', {
    path: '/store/billing-invoicing/payout',
    archiveLoadUrl: '/orders/billing-invoicing/payout',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_SELLER]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Billing & Invoicing',
      // icon: 'ordered-list',
      archiveConfig: {
        title: 'Payout',
        label: 'Payouts',
        createButtonSupported: false,
        // icon: 'ordered-list',
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
      },
      singleLoadUrl: `/~/:id/?${
        [
          'store=true',
        ].join('&')
      }`,

      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        getPageFields: getI18nFields,
        renderHeaderTitle: (props) => (
           props.data?.name
            ? (
                <span style={{ textTransform: 'capitalize' }}>
                  {props.data.name || 'N/A'}
                </span>
              )
            : 'Payout'
    ),
      },
      singleEditConfig: {
        actions: [
          ['ActionSave', {
            handleSuccess: (data, props) => props.reload(),
          }],
        //  ['ActionDelete'],
        ],
      },
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
            forRole === 'ADMIN'
          ? '/store/'
          : forRole === 'SELLER'
          ? '/'
          : null,
        ],
      ],
      columns: COLUMNS,
      filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
